module.exports = __webpack_public_path__ + "static/media/health-small-placeholder.2bea3510.webp";